@if (has_transaction || isLoading) {
  <div class="add-finacial-body">
    <div class="upper-section">
      <div>
        <p class="attibute-title">Transactions</p>
      </div>
      <div>
        <span>
          <mat-slide-toggle
            [checked]="showTransactionInfo"
            [disabled]="isRemoveEditSaveSharing"
            (click)="!isRemoveEditSaveSharing && toggleTransactionView($event)"
            ></mat-slide-toggle
          ></span>
        </div>
      </div>
      @if (isLoading) {
        <div class="add-finacial-body">
          <div class="loader-container">
            <div class="flex loader-body">
              <div class="ph-item width-100per loader-body-item">
                <div class="ph-col-12" style="padding: 0px !important">
                  <div class="ph-row">
                    <div class="ph-col-12"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      }
      @if (showTransactionInfo) {
        <div class="bottom-section">
          <span class="afin-btn hover:cursor-pointer" (click)="handleTransactionRegisterDrawerEvent()">
            <span class="material-icons">list</span> View Register
          </span>
          <div>
            @if (totalCount == 0) {
              <p class="sub-title">Nothing to show</p>
            }
            @if (showReviewCOunt) {
              <p class="red-marker">
                <strong>{{ reviewedCount }}</strong> Not Reviewed
              </p>
            }
            @if (showCompleteCount && totalCount > 0) {
              <p class="complet-marker">
                <span class="material-icons small-black-icon">done</span>
                All transactions reviewed
              </p>
            }
          </div>
        </div>
      }
    </div>
  }
